import { createSelector } from 'reselect';
export var CustomTilesStoreSelector = function CustomTilesStoreSelector(state) {
  return state.customercare.customTileResults;
};
export var CustomTilesResultSelector = createSelector([CustomTilesStoreSelector], function (tilesStore) {
  return tilesStore.data;
});